import { ReactElement, lazy, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import appPage from '../../../hoc/appPage';
import dataModel from '../../../models/data';
import toastsModel, { Preset } from '../../../models/toasts';
import { usePartnerConfig } from '../../../contexts/partnerConfig';
import { Headers } from '../../../components/Headers';
import { SSOOnboardForm } from '../../../forms/SSO/OnboardForm';

const UnavailableView = lazy(() => import('../../../views/UnavailableView'));

function SSOOnboardPage(): ReactElement {
  const {
    email,
    country,
    brandingInfo: { clientId }
  } = dataModel;

  const { t } = useTranslation();
  const [canOnboard, setCanOnboard] = useState(true);
  const { config } = usePartnerConfig();
  const {
    oauthConsentTosLink = '',
    oauthConsentPpLink = '',
    oauthConsentNotice
  } = config?.myAccount || {};

  useEffect(() => {
    if (!config) return;

    // TODO: when all clients provides us with 2 links, we can make this an "&&" condition
    const haveRequiredLinks = oauthConsentTosLink || oauthConsentPpLink;

    // we will not be able to determine tos link existence without `client_id` and `country`
    // hence showing this error only when we can determine it and the value is still missing
    if (clientId && country && !haveRequiredLinks) {
      toastsModel.add({
        text: t('SSOOnboardForm.toast.missingClientTosOrPpLink'),
        preset: Preset.Danger
      });
    }

    setCanOnboard(Boolean(country && haveRequiredLinks && email));
  }, [config]);

  if (!canOnboard) return <UnavailableView />;

  return (
    <div className="sso-onboard-page">
      <Headers />
      <SSOOnboardForm
        oauthConsentTosLink={oauthConsentTosLink}
        oauthConsentPpLink={oauthConsentPpLink}
        oauthConsentNotice={oauthConsentNotice}
      />
    </div>
  );
}

export default appPage(SSOOnboardPage);
